export default "__VITE_ASSET__331290e3__"